export default __webpack_public_path__ + "static/media/article_card_desktop.2625a37e.svg";